module.exports = __webpack_public_path__ + "img/workCenter.847388b5.png";